import '@babel/polyfill'
// import 'classlist-polyfill'
import '@/core/lazy_use'
import '@/styles/index.less'
import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/store'
import bootstrap from '@/core/bootstrap'
import './assets/fonts/iconfont'
import 'video.js/dist/video-js.css'
import { getUID } from '@/utils/util'
Vue.mixin({
	methods: {
		getUID,
	},
})

import '@/directives/index'

import '@/permission' // permission control
import '@/utils/filter' // global filter

Vue.config.productionTip = false

new Vue({
	router,
	store,
	created() {
		bootstrap()
	},
	render: (h: any) => h(App),
	el: '#app',
})
